export {
    default as Spinner,
    ISpinnerProps,
} from './spinner';
